import { areaSaggioPiantaCampioneStore } from '@/modules/AreaSaggioPiantaCampione/store/areaSaggioPiantaCampione.store';
import { reportStore } from '../store/report.store';
import { valenzaDenrologica } from './valenzaDenrologica';

export class CalculationUtils {
    public static getAreaClasseDiametrica(diametro: number): number {
        return Math.PI * Math.pow(diametro, 2);
    }

    public static getAreaInMq(area?: number): number {
        return area || 0;
    };

    public static getAreaInHa(areaInMq: number): number {
        return areaInMq > 0 ? 10000 / areaInMq : areaInMq;
    }

    public static getNumeroPianteAdEttaro(contatore: number, areaInHa: number): number {
        return Math.ceil(Math.abs(contatore) * areaInHa);
    };

    public static getAltezzaIpsometrica(diametro: number): number {
        if (diametro === 0) return 0;

        const regression = reportStore.getters.regression();
        if(!regression) return 0;

        return Math.round(regression.fn(diametro) * 100) / 100;
    }

    public static getAreaBasimetricaAdEttaro(areaClasseDiametrica: number, numeroPianteAdEttaro: number): number {
        return (areaClasseDiametrica / 40000) * numeroPianteAdEttaro
    }

    public static getVolumeUnitario(codiceSpecie: string, diametro: number, altezzaIpsometrica: number): number {
        return valenzaDenrologica.getVolumeUnitario(codiceSpecie, diametro, altezzaIpsometrica);
    };

    public static getVolumeAdEttaro(numeroPianteAdEttaro: number, volumeUnitario: number): number {
        return numeroPianteAdEttaro * volumeUnitario;
    };

    public static getDiametroMedio(areaBasimetricaAdEttaro: number, numeroPianteAdEttaro: number): number {
        if (areaBasimetricaAdEttaro != 0 && numeroPianteAdEttaro != 0) {
            return Math.sqrt(areaBasimetricaAdEttaro * 40000 / Math.PI / numeroPianteAdEttaro);
        }
        return 0;
    };
}